// frontend/src/lib/csrf.ts
// Guarantees a valid Sanctum CSRF cookie before any unsafe request.
// Safe to call many times; it will no-op after the first success.

let csrfReady: Promise<void> | null = null;

export function ensureCsrf(): Promise<void> {
  if (!csrfReady) {
    csrfReady = fetch('/sanctum/csrf-cookie', {
      method: 'GET',
      credentials: 'include',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store',
    }).then(res => {
      if (!res.ok) throw new Error(`CSRF cookie fetch failed: ${res.status}`);
    }).catch(err => {
      csrfReady = null; // allow another attempt next time
      throw err;
    });
  }
  return csrfReady;
}
